import React from 'react'

interface IPlaceholderProps {
  width?: string
  className?: string
  small?: boolean
}

export function Placeholder({ className = '', small }: IPlaceholderProps) {
  const cssClass = small ? 'placeholder--small' : 'placeholder'
  return <span className={`${cssClass} ${className}`} />
}

export default React.memo(Placeholder)
